export default {
  // 2-16
  org_choicelist: [],
  org_applier: [],
  org_applierlist: [],
};
